export default __webpack_public_path__ + "static/media/earth.3df36b5b.png";